import { authPersistenceService } from '@/infra';
import { closeAll } from '@heroui/toast';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUserEntityStore, AuthUserRepositoryStore } from '../models';

export const defaultAuthState: AuthUserEntityStore = {
  id: null,
  name: null,
  email: null,
  run: null,
  role: null,
  token: null,
  es_admin: null,
  ultimo_acceso: null,
  cod_tipo_perfil: null,
  desc_tipo_perfil: null,
};

/**
 * Store de autenticación con persistencia encriptada
 * Gestiona sesión de usuario y token de autenticación
 * Utiliza authPersistenceService para almacenamiento seguro en localStorage
 */
export const useAuthStore = create<AuthUserRepositoryStore>()(
  persist(
    (set) => ({
      ...defaultAuthState,

      /**
       * Almacena datos de usuario autenticado en el store
       * Persiste información encriptada en localStorage
       *
       * @param params - Datos completos del usuario autenticado (id, name, email, token, etc.)
       */
      login: (params: AuthUserEntityStore) => {
        set(params);
      },

      /**
       * Cierra sesión del usuario actual
       * Limpia datos del store y elimina toda información persistida de la aplicación
       */
      logout: () => {
        closeAll();
        set(defaultAuthState);
        authPersistenceService.clearAllAppData();
      },
    }),
    {
      name: '@app/auth',
      storage: {
        getItem: (name) => {
          return authPersistenceService.loadAuthData(name);
        },

        setItem: (name, value) => {
          authPersistenceService.saveAuthData(name, value);
        },

        removeItem: (name) => {
          authPersistenceService.removeAuthData(name);
        },
      },
    },
  ),
);
